module.exports = __webpack_public_path__ + "img/powered-by-pocket-rocket.3876e8df.svg";